import React from "react";
import { Button, Col, Container, Row, Link, HeadingText } from '@paypalcorp/pp-react';
import { parseMessages } from '../../../utilityHelper';
import withTheme from "../../../common/withTheme";
import { getCdnHostName } from '@paypalcorp/instance-location';
const messages = parseMessages("ppcc/confirmation/confirmation-home").ppcc;

const GSHeroComponent = (props) => {
    return (
        <section style={props.bgColor} className='sectionDetails'>
            <Container>
                <Row className={props.rowClass}>
                    <Col xs={12} xxl={6} className="demo-content">
                        <HeadingText style={{ paddingBottom: '1rem' }} size='lg'>
                            {props.headMessage}
                        </HeadingText>
                        <p>{props.headSub}</p>
                        {props.headSecondarySub &&
                            <p>{props.headSecondarySub}</p>
                        }
                        {props.linkExists &&
                            <Link href={props.linkURL} data-fpti={props.linkFPTI} target='_blank'>{props.linksMessage}</Link>
                        }
                    </Col>
                    <Col xs={12} xxl={6}>
                        <img alt="" src={props.imagePath} />
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

const GetStartedHero = (props) => {
    const donationSubHead = (messages && messages.donationsubhead) ? messages.donationsubhead.replace('{ppccTxnRate}', props.ppccTxnRate) : '';

    return (
        <>
            <section className="sectionDetails">
                <Container>
                    <Row>
                        <Col xs={12} xxl={8} className="demo-content">
                            <HeadingText style={{ paddingBottom: '1rem' }} size='lg'>{messages.heading}</HeadingText>
                            <p>{messages.subheading}</p>
                        </Col>
                        <Col xs={12} xxl={4} className="flexAlignRight">
                            <Button data-fpti="get_started" id="primaryConfirmAccount" as="a" href="/charities/dashboard">{messages.confirmbtn}</Button>
                        </Col>
                    </Row>
                </Container>
            </section>

            <GSHeroComponent
                bgColor={{ backgroundColor: '#FAF8F5' }}
                headMessage={messages.donationhead}
                headSub={donationSubHead}
                linkExists={true}
                linkURL='/webapps/mpp/paypal-fees'
                linkFPTI='full_pricing_details'
                linksMessage={messages.donationpricing}
                imagePath={`https://${getCdnHostName()}/causes/${props.countryCode}/Donation_Flow_Preview.png`} />

            <GSHeroComponent
                rowClass='content-right'
                headMessage={messages.ppgfhead}
                headSub={messages.ppgfsubhead}
                {...props.countryCode == 'GB' && { headSecondarySub: messages.ppgfsubhead2 }}
                imagePath={`https://${getCdnHostName()}/causes/${props.countryCode}/PPGF_Dashboard_Preview.png`} />

            {props.grantSection &&
                <GSHeroComponent
                    bgColor={{ backgroundColor: '#FAF8F5' }}
                    headMessage={messages.grantshead}
                    headSub={messages.grantssubhead}
                    imagePath={`https://${getCdnHostName()}/causes/${props.countryCode}/Grant_Payments_Preview.png`} />
            }

            {props.venmoSection &&
                <GSHeroComponent
                    rowClass='content-right'
                    headMessage={messages.venmohead}
                    headSub={messages.venmosubhead}
                    imagePath={`https://${getCdnHostName()}/ppcp/appcenterDetailPages/venmo_charity/US/Image-1-20220603.png`} />
            }

            <section style={{ backgroundColor: '#003087' }} className='sectionDetails'>
                <Container>
                    <Row>
                        <Col xs={12} xxl={8} className="demo-content">
                            <HeadingText size="sm" style={{ color: 'white' }}>
                                {messages.secondaryaction}
                            </HeadingText>
                        </Col>
                        <Col xs={12} xxl={4} className="flexAlignRight">
                            <Button data-fpti="get_started_secondary" as="a" href="/charities/dashboard" inverse>{messages.confirmbtn}</Button>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    )
}

export default withTheme(GetStartedHero);